export default __webpack_public_path__ + "static/media/Merike.d0411bba.png";